import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
} from "../../components";

import "./styles.css";

const Activities = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );

  const [extraActivities, setExtraActivities] = useState([
    {
      orgName: "",
      timeSpent: "",
      position: "",
      certificate: "",
    },
  ]);

  useEffect(() => {
    setExtraActivities(
      questionnaire?.extraActivities?.length > 0
        ? questionnaire?.extraActivities
        : [
            {
              orgName: "",
              timeSpent: "",
              position: "",
              certificate: "",
            },
          ]
    );
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      {extraActivities?.map((activity, index) => (
        <div className={`${index > 0 ? "mt-6" : ""} `}>
          <div className="section-header">Activity {index + 1}</div>
          <div className="grid grid-cols-2 gap-x-7 gap-y-6" key={index}>
            <div>
              <questionnaireComponents.QuestionnaireLabel text="Organization/Club Name" />
              <Spacer height="0.3125em" />
              <questionnaireComponents.QuestionnaireValueBox
                value={activity.orgName}
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel text="Total Spending Time" />
              <Spacer height="0.3125em" />
              <questionnaireComponents.QuestionnaireValueBox
                value={activity.timeSpent}
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel text="Position" />
              <Spacer height="0.3125em" />
              <questionnaireComponents.QuestionnaireValueBox
                placeholder="Enter position"
                value={activity.position}
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel text="Certificate" />
              <Spacer height="0.3125em" />
              <questionnaireComponents.QuestionnaireFileInput
                type="file"
                photo={activity?.certificate}
              />
            </div>
          </div>
        </div>
      ))}

      <Spacer height="1.25em" />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("Academics")}
          >
            Next
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default Activities;
